import SetPassword from '@routes/_public/-setPassword';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/activate-account/$token')({
  component: ActivateAccount,
});

function ActivateAccount() {
  const { token } = Route.useParams();
  return <SetPassword context="activate-account" token={token} />;
}
